import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const VideoPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Videos}
        fetchRecordsUrl={AdminReqUrls.admin__vid__mainPage_fetch_recordList}
    />)
});
export default VideoPage;
